import React from 'react';

const Skills = () => {
  const skills = [
    { name: 'IoT Integration', percentage: 95 },
    { name: 'Automation Engineering', percentage: 90 },
    { name: 'AI & Machine Learning', percentage: 85 },
    { name: 'AR/VR Solutions', percentage: 80 }
  ];

  return (
    <section className="bg-dark-1 pb-0">
      <div className="container-fluid px-0">
        <div className="row no-gutters">
          <div className="col-lg-6">
            <div className="hero-wrap h-100">
              <div className="hero-mask opacity-3 bg-dark"></div>
              <div className="hero-bg hero-bg-scroll" style={{backgroundImage: "url('https://images.pexels.com/photos/256219/pexels-photo-256219.jpeg')"}}></div>
              <div className="hero-content h-100 py-5 py-lg-0 px-xl-5">
                <div className="container h-100 d-flex py-5 py-lg-0 px-md-5">
                  <div className="bg-primary shadow-lg text-center my-auto mx-5 p-5">
                    <p className="lead text-white text-6 line-height-4 mb-0">Innovative, tech-driven, and results-focused, RovoAutomation delivers cutting-edge IoT and automation solutions that transform industries.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="p-5 my-4 my-sm-5 mx-sm-5">
              <h2 className="text-9 text-light font-weight-400 mb-3">Empowering Your Business with Smart Technology!</h2>
              <p className="lead text-muted mb-4">Rovo Automation specializes in IoT integration and automation engineering, delivering intelligent solutions that drive efficiency and innovation.</p>
              {/* {skills.map((skill, index) => (
                <div key={index}>
                  <p className="text-light text-left mb-2">{skill.name} <span className="float-right">{skill.percentage}%</span></p>
                  <div className="progress progress-sm bg-dark-3 mb-4">
                    <div className="progress-bar bg-dark-5" role="progressbar" style={{width: `${skill.percentage}%`}}></div>
                  </div>
                </div>
              ))} */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
